/* eslint-disable no-nested-ternary */
import styled, { css } from "styled-components";
import { bp } from "theme/mediaQuery";
import Button from "components/ThemedComponent/Common/Button";
import { isHostLaunchedMicrosite } from "utils";
import { getGlobalCSSVariants } from "theme";

export const Overlay = styled.div`
	position: fixed;
	background: rgba(0, 0, 0, 0.7);
	display: flex;
	justify-content: flex-end;
	left: 0;
	right: 0;
	bottom: 0;
	top: 0;
	z-index: 100;
`;
export const Container = styled.section`
	background: #ffffff;
	width: 100%;
	height: 100vh;
	z-index: 9999999;
	${bp.md} {
		width: 524px;
	}
`;

export const MobileContainer = styled.section`
	background: #ffffff;
	width: 100%;
	max-height: 700px;
	height: 100%;
	z-index: 9999999;
	position: relative;
	${bp.md} {
		width: 524px;
	}
	padding-top: 16px;
	border-radius: 8px 8px 0 0;
`;

export const Header = styled.div`
	padding: 24px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid #eaedf2;
	height: 76px;
`;
export const Heading = styled.h2`
	font-weight: 600;
	font-size: 20px;
	line-height: 28px;
	color: #8c8594;
	margin: 0;
`;
export const CloseIcon = styled.div`
	cursor: pointer;
	svg {
		height: 24px;
		width: 24px;
	}
`;
export const FiltersContainer = styled.div<{ isBottomListItems?: boolean }>`
	display: flex;
	max-height: 700px;

	${({ isBottomListItems }) =>
		isBottomListItems &&
		css`
			height: calc(100% - 170px);

			${bp.md} {
				height: calc(100% - 245px);
			}
		`}
`;
export const ChoicesContainer = styled.div`
	width: 230px;
	background: #f4f2f6;
	overflow: auto;
	padding-bottom: 100px;
`;
export const Choice = styled.div<{ isActive: boolean }>`
	font-size: 14px;
	line-height: 20px;
	color: #190a28;
	padding: 16px;
	cursor: pointer;
	display: flex;
	justify-content: space-between;

	${({ isActive }) =>
		isActive &&
		css`
			font-weight: 600;
			background: #ffffff;
			padding: 16px;

			${bp.md} {
				padding: 16px 16px 16px 24px;
			}
		`}

	${bp.md} {
		font-size: 16px;
		line-height: 24px;
		margin-bottom: 8px;
		padding: 12px 16px 12px 24px;
	}
	border-left: ${(props) =>
		props.isActive ? `4px solid ${getGlobalCSSVariants().primaryColor}` : "none"};
`;
export const OptionsContainer = styled.div`
	width: 100%;
	padding: 4px 16px;
	overflow: auto;
	max-height: 700px;
	height: 100%;
	background: white;
`;
export const StatsBar = styled.div`
	background: #8c8594;
	padding: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 36px;
`;
export const Text = styled.span`
	font-size: 14px;
	line-height: 20px;
	color: #ffffff;
`;
export const Separator = styled.div`
	margin: 0 12px;
	font-size: 8px;
	color: #ffffff;
`;
export const FooterContainer = styled.div`
	position: sticky;
	bottom: 0;
	width: 100%;
	${bp.md} {
		width: 524px;
	}
`;
export const Footer = styled.div`
	background: #ffffff;
	padding: 16px 24px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	${bp.md} {
		justify-content: flex-end;
	}
`;
export const ClearButton = styled(Button)<{ disableBtn: boolean }>`
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
	color: ${isHostLaunchedMicrosite()
		? getGlobalCSSVariants()?.primaryColor
		: "#1F8268"};
	padding: 12px;
	${bp.md} {
		margin-right: 24px;
	}
	border: ${(props) => (props.disableBtn ? "none" : "")};
	color: ${(props) => (props.disableBtn ? "gray" : "#1F8268")};
	&:active {
		color: ${(props) => (props.disableBtn ? "gray" : "#1F8268")};
	}
	&:hover {
		color: ${(props) => (props.disableBtn ? "gray" : "#1F8268")};
	}
	&:disabled {
		background: none;
	}
`;
export const ApplyButton = styled(Button)<{ disableBtn: boolean }>`
	padding: 8px 16px;
	border-radius: 4px;
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
	min-width: 156px;
	background: ${(props) => (props.disableBtn ? "#dae0e5" : "#1F8268")};
	border: ${(props) => (props.disableBtn ? "none" : "")};
	${bp.md} {
		padding: 8px 16px;
		width: auto;
	}

	&:hover {
		background: ${(props) => (props.disableBtn ? "#dae0e5" : "#1F8268")};
		color: ${(props) => (props.disableBtn ? "#fff" : "#fff")};
	}
`;
export const LineSeparator = styled.div`
	width: 100%;
	border-top: 1px solid #e8e7ea;
	margin: 10px 0;
`;
